import React, { ReactElement } from 'react';

import { Svg } from '@pb/shared/ui/atoms/svg';
import { TMyPurplebricksLogoProperties } from './my-purplebricks-logo.types';

export function MyPurplebricksLogo({
    type = 'small',
}: TMyPurplebricksLogoProperties): ReactElement {
    if (type === 'large') {
        return (
            <Svg
                width={171}
                height={16}
                color="darkPurple"
                viewBox="0 0 1068 102"
            >
                <path
                    d={`M38.1,74.32L21.6,41.85v53.92c0,2.61-1.24,3.85-3.85,3.85H3.85C1.24,99.62,0,98.39,0,95.77V6.36
		c0-2.61,1.24-3.85,3.85-3.85h13.2c2.48,0,3.85,0.83,4.68,2.61l19.95,39.2l19.81-39.2c0.83-1.79,2.2-2.61,4.68-2.61h13.2
		c2.75,0,3.85,1.24,3.85,3.85v89.41c0,2.61-1.1,3.85-3.85,3.85H65.47c-2.61,0-3.71-1.24-3.71-3.85V41.85L45.12,74.32
		c-0.69,1.51-1.65,2.48-3.44,2.48C39.75,76.79,38.79,75.83,38.1,74.32z
		M141.41,95.77c0,2.61-1.24,3.85-3.85,3.85h-14.44c-2.61,0-3.85-1.24-3.85-3.85V63.45L93.13,7.19
		c-0.96-2.06-0.28-4.68,2.75-4.68h15.27c3.03,0,4.26,1.51,5.09,3.58l9.9,25.31l3.99,13.21h0.41l4.13-13.21l9.9-25.31
		c0.83-2.06,2.06-3.58,4.95-3.58h15.27c3.16,0,3.71,2.61,2.75,4.68l-26.13,56.26V95.77z
		M213.07,99.62c-2.61,0-3.85-1.24-3.85-3.85V6.36c0-2.61,1.24-3.85,3.85-3.85h26.41
		c25.03,0,36.45,8.67,36.45,35.08c0,26.27-11.42,34.94-36.45,34.94h-8.25v23.25c0,2.61-1.24,3.85-3.85,3.85H213.07z M239.35,53.27
		c10.59,0,14.17-3.58,14.17-15.68s-3.58-15.68-14.17-15.68h-8.12v31.36H239.35z
		M287.77,67.85V6.36c0-2.61,1.24-3.85,3.85-3.85h14.44c2.61,0,3.85,1.24,3.85,3.85v59.01
		c0,10.87,3.16,15.68,11.83,15.68c8.53,0,11.69-4.81,11.69-15.54V6.36c0-2.61,1.24-3.85,3.85-3.85h14.44c2.61,0,3.85,1.24,3.85,3.85
		v61.49c0,22.83-11,33.15-33.84,33.15C298.77,101,287.77,90.68,287.77,67.85z
		M400.98,2.51c24.9,0,36.45,8.67,36.45,33.7c0,16.51-6.6,25.59-17.74,29.44l16.78,29.16
		c1.51,2.61,0.69,4.81-2.34,4.81h-14.99c-2.89,0-4.13-0.96-5.36-3.16l-14.85-27.51h-7.15v26.82c0,2.61-1.24,3.85-3.85,3.85H373.6
		c-2.61,0-3.85-1.24-3.85-3.85V6.36c0-2.61,1.24-3.85,3.85-3.85H400.98z M400.84,50.52c10.87,0,14.17-3.99,14.17-14.31
		c0-10.87-3.44-14.3-14.31-14.3h-8.94v28.61H400.84z
		M453.11,99.62c-2.61,0-3.85-1.24-3.85-3.85V6.36c0-2.61,1.24-3.85,3.85-3.85h26.41
		c25.03,0,36.45,8.67,36.45,35.08c0,26.27-11.42,34.94-36.45,34.94h-8.25v23.25c0,2.61-1.24,3.85-3.85,3.85H453.11z M479.38,53.27
		c10.59,0,14.17-3.58,14.17-15.68s-3.58-15.68-14.17-15.68h-8.12v31.36H479.38z
		M550.36,79.54h26.68c2.61,0,3.85,1.24,3.85,3.85v12.38c0,2.61-1.24,3.85-3.85,3.85h-44.98
		c-2.61,0-3.85-1.24-3.85-3.85V6.36c0-2.61,1.24-3.85,3.85-3.85h14.44c2.61,0,3.85,1.24,3.85,3.85V79.54z
		M614.46,59.46v20.77h30.4c2.61,0,3.85,1.24,3.85,3.85v11.69c0,2.61-1.24,3.85-3.85,3.85h-48.42
		c-2.61,0-3.85-1.24-3.85-3.85V6.36c0-2.61,1.24-3.85,3.85-3.85h47.87c2.61,0,3.85,1.24,3.85,3.85v11.69c0,2.61-1.24,3.85-3.85,3.85
		h-29.85v18.98h28.34c2.48,0,3.71,1.24,3.71,3.85v11c0,2.48-1.24,3.71-3.71,3.71H614.46z
		M664.67,99.62c-2.61,0-3.85-1.24-3.85-3.85V6.36c0-2.61,1.24-3.85,3.85-3.85h29.99
		c21.6,0,33.15,6.05,33.15,25.03c0,11.97-5.64,17.88-11.83,20.36c7.98,2.48,14.44,9.77,14.44,23.25c0,20.63-13.07,28.47-34.11,28.47
		H664.67z M693.83,41.3c8.8,0,12.24-3.16,12.24-10.59c0-7.43-3.16-10.04-12.1-10.04h-11.42V41.3H693.83z M694.79,81.47
		c10.04,0,13.62-3.03,13.62-11.55c0-8.25-3.58-11.55-13.34-11.55h-12.52v23.11H694.79z
		M773.48,2.51c24.9,0,36.45,8.67,36.45,33.7c0,16.51-6.6,25.59-17.74,29.44l16.78,29.16
		c1.51,2.61,0.69,4.81-2.34,4.81h-14.99c-2.89,0-4.13-0.96-5.36-3.16l-14.85-27.51h-7.15v26.82c0,2.61-1.24,3.85-3.85,3.85H746.1
		c-2.61,0-3.85-1.24-3.85-3.85V6.36c0-2.61,1.24-3.85,3.85-3.85H773.48z M773.34,50.52c10.87,0,14.17-3.99,14.17-14.31
		c0-10.87-3.44-14.3-14.31-14.3h-8.94v28.61H773.34z
		M822.45,6.36c0-2.61,1.24-3.85,3.71-3.85h14.58c2.61,0,3.85,1.24,3.85,3.85v89.41c0,2.61-1.24,3.85-3.85,3.85
		h-14.58c-2.48,0-3.71-1.24-3.71-3.85V6.36z
		M913.09,79.13c2.89-0.96,4.13,0,4.81,2.61l2.61,10.32c0.69,2.61-0.41,3.71-2.89,4.81
		c-4.26,2.06-11.97,4.13-20.36,4.13c-26,0-39.75-12.79-39.75-50.07c0-37,13.34-49.93,39.2-49.93c8.25,0,15.54,2.2,19.94,4.13
		c2.48,1.1,3.71,2.06,3.03,4.81l-2.61,10.32c-0.55,2.48-1.93,3.44-4.81,2.48c-2.75-0.82-7.01-1.93-11.69-1.93
		c-14.99,0-20.49,7.15-20.49,30.12c0,23.25,5.78,30.4,21.04,30.4C905.94,81.33,910.34,80.09,913.09,79.13z
		M975.54,5.95c1.38-1.93,2.61-3.44,5.36-3.44h15.96c2.89,0,3.71,2.48,2.2,4.81l-27.1,39.61l28.2,47.87
		c1.38,2.48,0.55,4.81-2.34,4.81H981.6c-2.61,0-3.99-1.51-5.23-3.58l-22.15-38.1v37.83c0,2.61-1.24,3.85-3.85,3.85h-14.44
		c-2.61,0-3.85-1.24-3.85-3.85V6.36c0-2.61,1.24-3.85,3.85-3.85h14.44c2.61,0,3.85,1.24,3.85,3.85v31.09L975.54,5.95z
		M1034.14,101c-9.77,0-19.4-1.93-24.48-3.99c-2.61-1.1-3.71-2.06-3.16-4.81l2.2-10.59
		c0.55-2.48,1.93-3.71,4.95-2.61c3.71,1.37,9.63,2.89,16.23,2.89c8.8,0,14.72-2.48,14.72-9.08c0-5.64-4.68-8.67-14.17-13.89
		c-11.97-5.91-23.11-12.93-23.11-30.95c0-18.43,10.18-26.82,31.91-26.82c8.94,0,16.78,1.79,21.05,3.44
		c2.48,0.96,3.58,1.93,3.03,4.68l-2.2,10.59c-0.55,2.48-1.93,3.3-4.81,2.48c-3.44-1.1-9.08-2.06-14.44-2.06
		c-8.25,0-11.97,2.2-11.97,8.12c0,6.05,5.91,10.04,13.62,14.17c13.48,7.43,23.66,13.62,23.66,30.67
		C1067.16,93.02,1052.58,101,1034.14,101z`}
                />
            </Svg>
        );
    }

    return (
        <Svg width={150} height={14} color="darkPurple" viewBox="0 0 1068 102">
            <path
                d={`M38.1,74.32L21.6,41.85v53.92c0,2.61-1.24,3.85-3.85,3.85H3.85C1.24,99.62,0,98.39,0,95.77V6.36
		c0-2.61,1.24-3.85,3.85-3.85h13.2c2.48,0,3.85,0.83,4.68,2.61l19.95,39.2l19.81-39.2c0.83-1.79,2.2-2.61,4.68-2.61h13.2
		c2.75,0,3.85,1.24,3.85,3.85v89.41c0,2.61-1.1,3.85-3.85,3.85H65.47c-2.61,0-3.71-1.24-3.71-3.85V41.85L45.12,74.32
		c-0.69,1.51-1.65,2.48-3.44,2.48C39.75,76.79,38.79,75.83,38.1,74.32z
		M141.41,95.77c0,2.61-1.24,3.85-3.85,3.85h-14.44c-2.61,0-3.85-1.24-3.85-3.85V63.45L93.13,7.19
		c-0.96-2.06-0.28-4.68,2.75-4.68h15.27c3.03,0,4.26,1.51,5.09,3.58l9.9,25.31l3.99,13.21h0.41l4.13-13.21l9.9-25.31
		c0.83-2.06,2.06-3.58,4.95-3.58h15.27c3.16,0,3.71,2.61,2.75,4.68l-26.13,56.26V95.77z
		M213.07,99.62c-2.61,0-3.85-1.24-3.85-3.85V6.36c0-2.61,1.24-3.85,3.85-3.85h26.41
		c25.03,0,36.45,8.67,36.45,35.08c0,26.27-11.42,34.94-36.45,34.94h-8.25v23.25c0,2.61-1.24,3.85-3.85,3.85H213.07z M239.35,53.27
		c10.59,0,14.17-3.58,14.17-15.68s-3.58-15.68-14.17-15.68h-8.12v31.36H239.35z
		M287.77,67.85V6.36c0-2.61,1.24-3.85,3.85-3.85h14.44c2.61,0,3.85,1.24,3.85,3.85v59.01
		c0,10.87,3.16,15.68,11.83,15.68c8.53,0,11.69-4.81,11.69-15.54V6.36c0-2.61,1.24-3.85,3.85-3.85h14.44c2.61,0,3.85,1.24,3.85,3.85
		v61.49c0,22.83-11,33.15-33.84,33.15C298.77,101,287.77,90.68,287.77,67.85z
		M400.98,2.51c24.9,0,36.45,8.67,36.45,33.7c0,16.51-6.6,25.59-17.74,29.44l16.78,29.16
		c1.51,2.61,0.69,4.81-2.34,4.81h-14.99c-2.89,0-4.13-0.96-5.36-3.16l-14.85-27.51h-7.15v26.82c0,2.61-1.24,3.85-3.85,3.85H373.6
		c-2.61,0-3.85-1.24-3.85-3.85V6.36c0-2.61,1.24-3.85,3.85-3.85H400.98z M400.84,50.52c10.87,0,14.17-3.99,14.17-14.31
		c0-10.87-3.44-14.3-14.31-14.3h-8.94v28.61H400.84z
		M453.11,99.62c-2.61,0-3.85-1.24-3.85-3.85V6.36c0-2.61,1.24-3.85,3.85-3.85h26.41
		c25.03,0,36.45,8.67,36.45,35.08c0,26.27-11.42,34.94-36.45,34.94h-8.25v23.25c0,2.61-1.24,3.85-3.85,3.85H453.11z M479.38,53.27
		c10.59,0,14.17-3.58,14.17-15.68s-3.58-15.68-14.17-15.68h-8.12v31.36H479.38z
		M550.36,79.54h26.68c2.61,0,3.85,1.24,3.85,3.85v12.38c0,2.61-1.24,3.85-3.85,3.85h-44.98
		c-2.61,0-3.85-1.24-3.85-3.85V6.36c0-2.61,1.24-3.85,3.85-3.85h14.44c2.61,0,3.85,1.24,3.85,3.85V79.54z
		M614.46,59.46v20.77h30.4c2.61,0,3.85,1.24,3.85,3.85v11.69c0,2.61-1.24,3.85-3.85,3.85h-48.42
		c-2.61,0-3.85-1.24-3.85-3.85V6.36c0-2.61,1.24-3.85,3.85-3.85h47.87c2.61,0,3.85,1.24,3.85,3.85v11.69c0,2.61-1.24,3.85-3.85,3.85
		h-29.85v18.98h28.34c2.48,0,3.71,1.24,3.71,3.85v11c0,2.48-1.24,3.71-3.71,3.71H614.46z
		M664.67,99.62c-2.61,0-3.85-1.24-3.85-3.85V6.36c0-2.61,1.24-3.85,3.85-3.85h29.99
		c21.6,0,33.15,6.05,33.15,25.03c0,11.97-5.64,17.88-11.83,20.36c7.98,2.48,14.44,9.77,14.44,23.25c0,20.63-13.07,28.47-34.11,28.47
		H664.67z M693.83,41.3c8.8,0,12.24-3.16,12.24-10.59c0-7.43-3.16-10.04-12.1-10.04h-11.42V41.3H693.83z M694.79,81.47
		c10.04,0,13.62-3.03,13.62-11.55c0-8.25-3.58-11.55-13.34-11.55h-12.52v23.11H694.79z
		M773.48,2.51c24.9,0,36.45,8.67,36.45,33.7c0,16.51-6.6,25.59-17.74,29.44l16.78,29.16
		c1.51,2.61,0.69,4.81-2.34,4.81h-14.99c-2.89,0-4.13-0.96-5.36-3.16l-14.85-27.51h-7.15v26.82c0,2.61-1.24,3.85-3.85,3.85H746.1
		c-2.61,0-3.85-1.24-3.85-3.85V6.36c0-2.61,1.24-3.85,3.85-3.85H773.48z M773.34,50.52c10.87,0,14.17-3.99,14.17-14.31
		c0-10.87-3.44-14.3-14.31-14.3h-8.94v28.61H773.34z
		M822.45,6.36c0-2.61,1.24-3.85,3.71-3.85h14.58c2.61,0,3.85,1.24,3.85,3.85v89.41c0,2.61-1.24,3.85-3.85,3.85
		h-14.58c-2.48,0-3.71-1.24-3.71-3.85V6.36z
		M913.09,79.13c2.89-0.96,4.13,0,4.81,2.61l2.61,10.32c0.69,2.61-0.41,3.71-2.89,4.81
		c-4.26,2.06-11.97,4.13-20.36,4.13c-26,0-39.75-12.79-39.75-50.07c0-37,13.34-49.93,39.2-49.93c8.25,0,15.54,2.2,19.94,4.13
		c2.48,1.1,3.71,2.06,3.03,4.81l-2.61,10.32c-0.55,2.48-1.93,3.44-4.81,2.48c-2.75-0.82-7.01-1.93-11.69-1.93
		c-14.99,0-20.49,7.15-20.49,30.12c0,23.25,5.78,30.4,21.04,30.4C905.94,81.33,910.34,80.09,913.09,79.13z
		M975.54,5.95c1.38-1.93,2.61-3.44,5.36-3.44h15.96c2.89,0,3.71,2.48,2.2,4.81l-27.1,39.61l28.2,47.87
		c1.38,2.48,0.55,4.81-2.34,4.81H981.6c-2.61,0-3.99-1.51-5.23-3.58l-22.15-38.1v37.83c0,2.61-1.24,3.85-3.85,3.85h-14.44
		c-2.61,0-3.85-1.24-3.85-3.85V6.36c0-2.61,1.24-3.85,3.85-3.85h14.44c2.61,0,3.85,1.24,3.85,3.85v31.09L975.54,5.95z
		M1034.14,101c-9.77,0-19.4-1.93-24.48-3.99c-2.61-1.1-3.71-2.06-3.16-4.81l2.2-10.59
		c0.55-2.48,1.93-3.71,4.95-2.61c3.71,1.37,9.63,2.89,16.23,2.89c8.8,0,14.72-2.48,14.72-9.08c0-5.64-4.68-8.67-14.17-13.89
		c-11.97-5.91-23.11-12.93-23.11-30.95c0-18.43,10.18-26.82,31.91-26.82c8.94,0,16.78,1.79,21.05,3.44
		c2.48,0.96,3.58,1.93,3.03,4.68l-2.2,10.59c-0.55,2.48-1.93,3.3-4.81,2.48c-3.44-1.1-9.08-2.06-14.44-2.06
		c-8.25,0-11.97,2.2-11.97,8.12c0,6.05,5.91,10.04,13.62,14.17c13.48,7.43,23.66,13.62,23.66,30.67
		C1067.16,93.02,1052.58,101,1034.14,101z`}
            />
        </Svg>
    );
}
